import { Image, Typography } from 'antd'
import React from 'react'
export const chooseCorrectPictureTable = [
  {
    title: 'Название',
    dataIndex: 'correctText',
    width: '15%'
  },
  {
    title: 'Дорожка',
    width: '5%',
    render: item => {
      let audioLink = item.audioUrl
      if (audioLink && !audioLink.startsWith('https://')) {
        audioLink = 'https://' + audioLink
      }
      return audioLink ? (
        <audio controls="controls">
          {audioLink && <source src={audioLink} type="audio/mpeg" />}
        </audio>
      ) : (
        <></>
      )
    }
  },
  {
    title: 'Варианты',
    width: '40%',
    render: item => (
      <div>
        {item.variants.map((variant, index) => (
          <div
            key={index}
            style={{
              marginBottom: '10px',
              backgroundColor: variant.isCorrect
                ? 'rgba(173, 255, 47, 0.5)'
                : 'rgba(255, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'space-around'
            }}
          >
            <strong>Текст:</strong> {variant.text}
            {variant.imageUrl && (
              <Image
                shape="square"
                style={{ width: 64, height: 64 }}
                src={variant.imageUrl}
              />
            )}
          </div>
        ))}
      </div>
    )
  }
]
